export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-foreground-950 mb-4">迷妹漫画</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              迷妹漫画是专注免费漫画阅读的在线平台，提供海量日漫、韩漫、国漫资源，支持下拉式竖屏滚动阅读，全本完结与连载作品免费畅享，是漫画爱好者的随身阅读乐园。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#cards" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热门推荐</a>
              <a href="#carousel" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">精选专题</a>
              <a href="#ranking" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">人气排行</a>
              <a href="#updates" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">最近更新</a>
              <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">阅读分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">日本漫画</a>
              <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">韩国漫画</a>
              <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">国产漫画</a>
              <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">完结漫画</a>
              <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">连载漫画</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              合作伙伴信息即将更新，敬请期待。
            </p>
            <div className="mt-4">
              <a href="#contact" className="text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer">
                <i className="ri-mail-line mr-1"></i>联系我们
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 迷妹漫画 · 免费漫画阅读乐园。本站内容仅供阅读交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}